/**
 * PostHog events for the marketing landing (`/`).
 * Event names: `POSTHOG_EVENTS` in `@/lib/posthog/events`.
 */

import type { PostHog } from 'posthog-js'
import { POSTHOG_EVENTS, safeCapture } from '@/lib/posthog'

export type LandingCtaPlacement = 'hero_primary' | 'hero_sign_in' | 'final_section'

export function trackLandingPageViewed(
  posthog: PostHog | undefined,
  properties?: {
    referrer?: string
  },
) {
  safeCapture(posthog, POSTHOG_EVENTS.LANDING_PAGE_VIEWED, properties ?? {})
}

export function trackLandingCtaClicked(
  posthog: PostHog | undefined,
  properties: {
    placement: LandingCtaPlacement
    destination: 'diy_index' | 'dashboard' | 'sign_in'
  },
) {
  safeCapture(posthog, POSTHOG_EVENTS.LANDING_CTA_CLICKED, properties)
}
